import { applyService } from "@/service"
import ActionId from "@/action/ActionId"
import BasePreAuthAction from "@/action/actions/BasePreAuthAction"

class SubmitPrequalifyAction extends BasePreAuthAction {

    #application = null

    constructor(providerKey, application) {
        super(ActionId.SUBMIT_PREQUALIFLY, providerKey)
        this.#application = application
    }

    async _submit() {
        return applyService.prequalify(this.providerKey, {
            application: this.#application,
        })
    }
}


export default SubmitPrequalifyAction
